export default ({ request }) => ({
  orderInspectionDocBatchUploadApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/batch/upload',
      method: 'post',
      data,
    })
  },
  orderInspectionDocUpdateApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/update',
      method: 'post',
      data,
    })
  },
  orderInspectionDocListApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/list',
      method: 'post',
      data,
    })
  },
  orderInspectionDocDetailApi(params = {}) {
    return request({
      url: '/factory/order/inspection/doc/detail',
      method: 'get',
      params,
    })
  },
  orderInspectionDocDelApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/del',
      method: 'post',
      data,
    })
  },
  orderInspectionDocBatchListApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/batch/list',
      method: 'post',
      data,
    })
  },
  orderInspectionDocBatchSaveApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/batch/save',
      method: 'post',
      data,
    })
  },
  orderInspectionDocBatchDelApi(data = {}) {
    return request({
      url: '/factory/order/inspection/doc/batch/del',
      method: 'post',
      data,
    })
  },
})
